// extracted by mini-css-extract-plugin
export default {"transitionDuration":"150ms","wrapperClass":"MGRyntnpp9YBdVditZxw"};